window.addEventListener('load', function() {
	const settings = {
		handler: 'OneTrust popupDataConsent',
		debug: {
			logs: false,
			errors: true
		},
		form: {
			selector: '.newsletter-modal__form',
		},
		input: {
			selector: 'input[name="contact[email]"]',
		},
		consent: {
			selector: '.ob-popup-checkbox-terms',
		},
		trigger: {
			action: 'click',
			selector: '#ob-newsletter-button'
		},
		purposeId: '42dc8be3-e3d1-4872-bd9b-1e21f1a39091',
		token: 'eyJhbGciOiJSUzUxMiJ9.eyJvdEp3dFZlcnNpb24iOjEsInByb2Nlc3NJZCI6ImEyMzJlNWY2LTBhNGQtNDhlMS04ZDMyLWZmMGNmZDNjNzZiZiIsInByb2Nlc3NWZXJzaW9uIjoxLCJpYXQiOiIyMDIyLTExLTIzVDE0OjU3OjA4LjcyIiwibW9jIjoiQVBJIiwicG9saWN5X3VyaSI6bnVsbCwic3ViIjoiRW1haWwiLCJpc3MiOm51bGwsInRlbmFudElkIjoiNWMxZDZmNDQtZWU3Mi00MGNiLTg1OGItZTE1OWU2Y2E5ODVkIiwiZGVzY3JpcHRpb24iOiJBUEkgb2JvdGljYXJpby5wdCIsImNvbnNlbnRUeXBlIjoiQ09ORElUSU9OQUxUUklHR0VSIiwiYWxsb3dOb3RHaXZlbkNvbnNlbnRzIjpmYWxzZSwiZG91YmxlT3B0SW4iOmZhbHNlLCJwdXJwb3NlcyI6W3siaWQiOiI0MmRjOGJlMy1lM2QxLTQ4NzItYmQ5Yi0xZTIxZjFhMzkwOTEiLCJ2ZXJzaW9uIjoyLCJwYXJlbnRJZCI6bnVsbCwidG9waWNzIjpbXSwiY3VzdG9tUHJlZmVyZW5jZXMiOltdLCJlbmFibGVHZW9sb2NhdGlvbiI6ZmFsc2V9XSwibm90aWNlcyI6W10sImRzRGF0YUVsZW1lbnRzIjpbXSwiYXV0aGVudGljYXRpb25SZXF1aXJlZCI6ZmFsc2UsInJlY29uZmlybUFjdGl2ZVB1cnBvc2UiOmZhbHNlLCJvdmVycmlkZUFjdGl2ZVB1cnBvc2UiOnRydWUsImR5bmFtaWNDb2xsZWN0aW9uUG9pbnQiOmZhbHNlLCJhZGRpdGlvbmFsSWRlbnRpZmllcnMiOltdLCJtdWx0aXBsZUlkZW50aWZpZXJUeXBlcyI6ZmFsc2UsImVuYWJsZVBhcmVudFByaW1hcnlJZGVudGlmaWVycyI6ZmFsc2UsInBhcmVudFByaW1hcnlJZGVudGlmaWVyc1R5cGUiOm51bGwsImFkZGl0aW9uYWxQYXJlbnRJZGVudGlmaWVyVHlwZXMiOltdLCJlbmFibGVHZW9sb2NhdGlvbiI6ZmFsc2V9.cdZ0RC2s_V9Ssop9UNKHC-0bBPkgbRkpUm_p_uwlwz_rqQmpiSW1t79S9x6KLu_nbpZ9rRiMpSbsRqT-w-KNfWbm8spoalJgkPGP_VgmhVy2LSNHW2l68b9mcW7IEBgkVomuoGqd7_NUrck7U4nOblmy68RSbC8DQpRfw0ykrJSi2e61e59mz-O7bxT-2qAGsuSOSyAhJNIWPOFCzUWuTzhZsMc3D6IaZFIZJWIRMVhY63HZSU2urga6nBPT4xZFa3nX_KYf01A7Uf_hB37qqOT5GR1aJkA8PkAGTpQRVXYaVekhkhCkQMQvNJOwaq1jisP4fRW9RZEEHZLzWkG39FAGC85CbrApag1OIhOnrWRSanZ4yYVmFaUubeG2pb7RNxvMI0RW4CpqqMd5AOeE2sENpTaPGmU_Im4-iB0-1-NONWeTxVQKAyoSmekJMyrW7zpOxF61XZpbESerzBSPWyZMnsSFq3-jrvdh7L75BhzAXsJHzenrWZiaoHTKAh06M6-yLvL6CW8cpLeGeSaQlVtqHuU5bv1pj8d_U-epurlpHi1_5Z2SQd3sJv9o9WucQZMy_MXrxOqweF1gkjjoVdF-kTVb5s0E1sX6_xSBaDCaTYWugRFjf3sys9KiTd8a5cjg4oxtu6IxI1mHsDDsp2VJX-5X2qSFnMc-ll-LqWk'
	};

	const log = (message, ...optionalParams) => {
		if (!settings.debug.logs) {
			return;
		}
		// eslint-disable-next-line no-console
		console.log(`${settings.handler}: ${message}`, ...optionalParams);
	};

	const error = (message, ...optionalParams) => {
		if (!settings.debug.errors) {
			return;
		}
		// eslint-disable-next-line no-console
		console.error(`${settings.handler}: ${message}`, ...optionalParams);
	};

	const findForm = () => {
		const candidates = Array.from(document.querySelectorAll(settings.form.selector));
		const forms = candidates.filter((candidate) => candidate instanceof HTMLFormElement);
		let target = undefined;
		if (forms.length > 1) {
			for (var i = 0; i < forms.length; i++) {
				if (forms[i].querySelector(settings.trigger.selector)) {
					target = forms[i];
					break;
				}
			}
		} else {
			target = forms[0];
		}
		return target;
	};

	const preparePayload = (checked, identifier) => {
		const transactionType = checked ? 'CONFIRMED' : 'WITHDRAWN';
		const payload = {
			identifier,
			requestInformation: settings.token,
			purposes: [
				{
					'Id': settings.purposeId,
					'TransactionType': transactionType
				}
			]
		};
		log('Payload', payload);
		return JSON.stringify(payload);
	};

	const uploadConsent = (payload) => {
		var xhr = new XMLHttpRequest();
		xhr.open('POST', 'https://privacyportal.onetrust.com/request/v1/consentreceipts', false);
		xhr.setRequestHeader('Content-type', 'application/json');
		xhr.onload = function () {
			if (xhr.status >= 200 && xhr.status < 300) {
				log('Consent uploaded successfully');
			} else {
				error('Consent upload failed', xhr.status, xhr.statusText);
			}
		};
		xhr.onerror = function () {
			error('Consent upload failed');
		};
		xhr.send(payload);
	};

	const form = findForm();
	if (!form) {
		log('Form not found');
		return;
	}

	log('Form found');

	form.addEventListener('submit', function () {
		const inputElement = form.querySelector(settings.input.selector);
		const consentElement = form.querySelector(settings.consent.selector);
		if (!inputElement || !consentElement) {
			error('Error to get form data');
			return;
		}
		log('Form submit');
		const checked = consentElement.checked || false;
		const identifier = inputElement.value || '';
		const payload = preparePayload(checked, identifier);
		uploadConsent(payload);
	});
});